import { z } from "zod";

export const loginSchema = z.object({
  email: z.string().email(),
  password: z.string().min(1),
  rememberMe: z.boolean().optional().default(true),
});
export type LoginInput = z.infer<typeof loginSchema>;

export const demoLoginSchema = z.object({
  roleKey: z.enum(["supplier", "planner", "compliance", "admin"]),
});

export const registerSchema = z.object({
  email: z.string().email(),
  password: z.string().min(8).max(64),
  firstName: z.string().min(1),
  lastName: z.string().min(1),
  company: z.string().min(1),
  officePhone: z.string().optional(),
  turnstileToken: z.string().min(1),
});
export type RegisterInput = z.infer<typeof registerSchema>;

export const forgotPasswordSchema = z.object({ email: z.string().email() });

export const resetPasswordSchema = z.object({
  email: z.string().email(),
  token: z.string().min(1),
  newPassword: z.string().min(8).max(64),
});

export const changePasswordSchema = z.object({
  oldPassword: z.string().min(1),
  newPassword: z.string().min(8).max(64),
});

/** Password policy — target state closes the legacy's 3-way inconsistency
 * (Forgot-Password config-driven vs. Change-Password min-length-8-only). */
export function evaluatePasswordPolicy(pw: string): { valid: boolean; reasons: string[] } {
  const reasons: string[] = [];
  if (pw.length < 8) reasons.push("At least 8 characters");
  if (pw.length > 64) reasons.push("At most 64 characters");
  if (!/[a-z]/.test(pw)) reasons.push("At least one lowercase letter");
  if (!/[A-Z]/.test(pw)) reasons.push("At least one uppercase letter");
  if (!/[0-9]/.test(pw)) reasons.push("At least one digit");
  if (!/[^a-zA-Z0-9]/.test(pw)) reasons.push("At least one special character");
  return { valid: reasons.length === 0, reasons };
}
